import { render, staticRenderFns } from "./QuadroDados.vue?vue&type=template&id=1f8c63e1"
import script from "./QuadroDados.vue?vue&type=script&lang=js"
export * from "./QuadroDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports